import { useSelector } from 'react-redux';
import { hasPermission, isRootAdminUser } from 'src/lib/utils';
import { userSelector } from 'src/store/apps/slices/UserSlice';

/**
 * Permission gate for UI. Optional `and` ANDs an extra boolean (e.g. region).
 * Backend remains the security authority.
 */
const WithPermission = ({ permission, children, fallback = null, and = true }) => {
  const { user } = useSelector(userSelector);
  const isRootAdmin = isRootAdminUser(user);

  if (and && hasPermission(user?.permissions, permission, isRootAdmin)) {
    return children;
  }

  return fallback;
};

export default WithPermission;
